import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/images/logo.svg";

function Header({ path, name }) {
    const nav = useNavigate();

    return (
        <header className="flex items-center justify-between mb-4 border-b">
            <div className="flex items-center bg-white rounded-2xl p-1 w-full justify-between">
                <Logo className="text-emerald-700 h-16 w-[88px] p-1" aria-hidden />
                <button
                    onClick={() => nav(path || "/")}
                    className="p-2 rounded-lg hover:bg-gray-100 text-gray-600 mr-2"
                    aria-label={name}
                >
                    {name}
                </button>
            </div>
        </header>
    );
}

export default Header;
